import {action, makeAutoObservable} from "mobx"
import {RootStore} from "../index";
import UserModel from "../../model/UserModel";
import LogModel from "../../model/LogModel";
import MessageViberModel from "../../model/MessageViberModel";
import OcrAiSettingsModel from "../../model/OcrAiSettingsModel";
import { EnumUserType } from "../../enum/EnumUserType";

export class PageAdminAuthStore {
    private rootStore: RootStore | undefined;

    public arUsers = [];
    public arLog = [];
    public pagination = {
        countPage: 1,
        countRow: 1,
        currentPage: 1
    }
    public limitRow = 10;
    public search = '';
    public searchLog = '';
    public error: string = '';
    public arrMessageViber: any = []
    public arrSystemProps: any = []

    constructor(rootStore?: RootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }

    init = () => {
        this.arUsers = [];
        if (!this.hasAdminAccess()) {
            this.handleUnauthorizedAccess();
            return;
        }
        this.reload();
    }

    @action
    reload() {
        if (!this.hasAdminAccess()) {
            this.handleUnauthorizedAccess();
            return;
        }
        UserModel.getAdminAll(this.setData, this.setError);
    }

    @action
    getLog() {
        if (!this.hasAdminAccess()) {
            this.handleUnauthorizedAccess();
            return;
        }
        LogModel.getAll(this.getModelData(),this.setLogData, this.setError);
    }

    @action
    getAllMessageViber() {
        if (!this.hasAdminAccess()) {
            this.handleUnauthorizedAccess();
            return;
        }
        MessageViberModel.getAllMessageViber(this.setMessageData, this.setError);
    }

    @action
    setMessageData = (result: any) => {
        this.arrMessageViber = result.data
        this.arrMessageViber.sort((a: any,b: any)=> Number(a.id) - Number(b.id))
    }

    @action
    onChangeArrayDataMessage = (id: string, value: string, position: string) => {
        if (this.arrMessageViber && this.arrMessageViber.length > 0){
            for (let i=0; i< this.arrMessageViber.length; i++){
                if (this.arrMessageViber[i].id === id ){
                    this.arrMessageViber[i].json[position] = value
                }
            }
        }
    }

    @action
    saveDataArrayMessage = (id: string) => {
        if (this.arrMessageViber && this.arrMessageViber.length > 0){
            for (let i=0; i< this.arrMessageViber.length; i++){
                if (this.arrMessageViber[i].id === id ){
                    MessageViberModel.updateMessageViber(Number(id), this.arrMessageViber[i],  this.setSaveResultAfterSave, this.setError)
                }
            }
        }
    }

    @action
    setSaveResultAfterSave = (result: any) => {
        this.getAllMessageViber()
        alert("Изменения сохранены")
    }

    getModelData() {
        return {
            json: {
                limit: this.limitRow,
                filter: {},
            },
            page: this.pagination.currentPage
        };
    }

    @action
    setData = (result: any) => {
        console.log(result)
        result.data.row.map((item: any) => {
            item.updatedAt = new Date(item.updatedAt);
            return item;
        });
        this.arUsers = result.data.row;
    }

    @action
    setLogData = (result: any) => {
        this.pagination = {
            countPage: 1,
            countRow: 1,
            currentPage: 1
        }
        this.arLog = [];
        this.pagination = result.data.pagination
        this.arLog = result.data.rows
    }
    onCurrentPage = (page: number) => {
        this.pagination.currentPage = page;
        this.getLog();
    }

    @action setError = (error: any) => {
        alert("Произошла ошибка...")
        console.log(error);
    }

    @action onFilterUser = (e: any) => {
        this.search = e.target.value;
    }
    @action onFilterLog = (e: any) => {
        this.searchLog = e.target.value;
    }

    // System Props methods
    @action
    getAllSystemProps() {
        if (!this.hasAdminAccess()) {
            this.handleUnauthorizedAccess();
            return;
        }
        OcrAiSettingsModel.getAllSettings(this.setSystemPropsData, this.setError);
    }

    private hasAdminAccess = () => {
        const token = localStorage.getItem("token");
        const userType = this.rootStore?.mainStore?.userType;
        const isAuth = Boolean(this.rootStore?.mainStore?.isAuth);

        return Boolean(token && isAuth && (userType === EnumUserType.adminAuth || userType === EnumUserType.root));
    }

    @action
    private handleUnauthorizedAccess = () => {
        this.arUsers = [];
        this.arLog = [];
        this.arrMessageViber = [];
        this.arrSystemProps = [];
        this.error = "Нет доступа";
    }

    @action
    setSystemPropsData = (result: any) => {
        if (result.data && result.data.length > 0) {
            this.arrSystemProps = result.data;
            this.arrSystemProps.sort((a: any, b: any) => Number(a.id) - Number(b.id));
        } else {
            // Если данных нет, создаем пустую запись для редактирования
            this.arrSystemProps = [{
                id: null,
                userPrompt: '',
                systemPrompt: '',
                synonyms: {}
            }];
        }
    }

    @action
    onChangeSystemProps = (id: string | number, field: string, value: any) => {
        // Если массив пуст, создаем временную запись для редактирования
        if (!this.arrSystemProps || this.arrSystemProps.length === 0) {
            this.arrSystemProps = [{
                id: null,
                userPrompt: '',
                systemPrompt: '',
                synonyms: {}
            }];
        }
        
        // Обновляем значение в записи
        if (this.arrSystemProps && this.arrSystemProps.length > 0) {
            const record = this.arrSystemProps[0];
            if (field === 'synonyms') {
                // Если это synonyms (jsonb), парсим строку в объект или оставляем как есть
                try {
                    record[field] = typeof value === 'string' ? JSON.parse(value) : value;
                } catch (e) {
                    record[field] = value;
                }
            } else {
                record[field] = value;
            }
        }
    }

    @action
    saveSystemProps = (id: string | number) => {
        // Если массив пуст, создаем временную запись
        if (!this.arrSystemProps || this.arrSystemProps.length === 0) {
            this.arrSystemProps = [{
                id: null,
                userPrompt: '',
                systemPrompt: '',
                synonyms: {}
            }];
        }
        
        if (this.arrSystemProps && this.arrSystemProps.length > 0) {
            const record = this.arrSystemProps[0];
            let synonyms = record.synonyms;
            // Если synonyms это строка, пытаемся распарсить
            if (typeof synonyms === 'string') {
                try {
                    synonyms = JSON.parse(synonyms);
                } catch (e) {
                    alert('Ошибка: Synonyms должен быть валидным JSON объектом');
                    return;
                }
            }
            const data = {
                userPrompt: record.userPrompt || '',
                systemPrompt: record.systemPrompt || '',
                synonyms: synonyms || {}
            };
            
            // Если id === 'new' или null, создаем новую запись, иначе обновляем существующую
            if (id === 'new' || id === null || !record.id) {
                OcrAiSettingsModel.createSettings(data, this.setSaveSystemPropsResult, this.setError);
            } else {
                OcrAiSettingsModel.updateSettings(Number(id), data, this.setSaveSystemPropsResult, this.setError);
            }
        }
    }

    @action
    saveUserPrompt = () => {
        if (!this.arrSystemProps || this.arrSystemProps.length === 0) {
            this.arrSystemProps = [{
                id: null,
                userPrompt: '',
                systemPrompt: '',
                synonyms: {}
            }];
        }
        
        if (this.arrSystemProps && this.arrSystemProps.length > 0) {
            const record = this.arrSystemProps[0];
            const data = {
                userPrompt: record.userPrompt || '',
                systemPrompt: record.systemPrompt || '',
                synonyms: record.synonyms || {}
            };
            
            if (!record.id) {
                OcrAiSettingsModel.createSettings(data, this.setSaveSystemPropsResult, this.setError);
            } else {
                OcrAiSettingsModel.updateSettings(Number(record.id), data, this.setSaveSystemPropsResult, this.setError);
            }
        }
    }

    @action
    saveSystemPrompt = () => {
        if (!this.arrSystemProps || this.arrSystemProps.length === 0) {
            this.arrSystemProps = [{
                id: null,
                userPrompt: '',
                systemPrompt: '',
                synonyms: {}
            }];
        }
        
        if (this.arrSystemProps && this.arrSystemProps.length > 0) {
            const record = this.arrSystemProps[0];
            const data = {
                userPrompt: record.userPrompt || '',
                systemPrompt: record.systemPrompt || '',
                synonyms: record.synonyms || {}
            };
            
            if (!record.id) {
                OcrAiSettingsModel.createSettings(data, this.setSaveSystemPropsResult, this.setError);
            } else {
                OcrAiSettingsModel.updateSettings(Number(record.id), data, this.setSaveSystemPropsResult, this.setError);
            }
        }
    }

    @action
    saveSynonyms = () => {
        if (!this.arrSystemProps || this.arrSystemProps.length === 0) {
            this.arrSystemProps = [{
                id: null,
                userPrompt: '',
                systemPrompt: '',
                synonyms: {}
            }];
        }
        
        if (this.arrSystemProps && this.arrSystemProps.length > 0) {
            const record = this.arrSystemProps[0];
            let synonyms = record.synonyms;
            if (typeof synonyms === 'string') {
                try {
                    synonyms = JSON.parse(synonyms);
                } catch (e) {
                    alert('Ошибка: Synonyms должен быть валидным JSON объектом');
                    return;
                }
            }
            const data = {
                userPrompt: record.userPrompt || '',
                systemPrompt: record.systemPrompt || '',
                synonyms: synonyms || {}
            };
            
            if (!record.id) {
                OcrAiSettingsModel.createSettings(data, this.setSaveSystemPropsResult, this.setError);
            } else {
                OcrAiSettingsModel.updateSettings(Number(record.id), data, this.setSaveSystemPropsResult, this.setError);
            }
        }
    }

    @action
    updateSynonyms = (synonyms: any) => {
        if (!this.arrSystemProps || this.arrSystemProps.length === 0) {
            this.arrSystemProps = [{
                id: null,
                userPrompt: '',
                systemPrompt: '',
                synonyms: {}
            }];
        }
        
        if (this.arrSystemProps && this.arrSystemProps.length > 0) {
            this.arrSystemProps[0].synonyms = synonyms;
        }
    }

    @action
    setSaveSystemPropsResult = (result: any) => {
        this.getAllSystemProps();
        alert("Изменения сохранены");
    }

}
